import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
// @ts-ignore
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin, Observable, Observer } from 'rxjs';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ViewFilePdfComponent } from '../view-file-pdf/view-pdf.component';
import { MatDialog } from '@angular/material';
import { EnumCustomerType, EnumFomatUploadFile, EnumFileTypeUpload, EnumTypeImage } from "src/app/core/constants/common"

@Component({
  selector: 'app-kyc-customer-infor',
  templateUrl: './kyc-customer-infor.component.html',
  styleUrls: ['./kyc-customer-infor.component.scss']
})
export class KycCustomerInforComponent implements OnInit, OnChanges {
  isModeImage: 'normal' | 'preview' = 'normal';
  @Input() type: 'personal' | 'enterprise' = 'personal';
  @Output() imageUpload: EventEmitter<any> = new EventEmitter();
  @Input() hasNote: boolean = false;
  @Input() listImageResponse: any[] = [];
  @Input() readonly: boolean = false
  @Input() isEnoughImage: boolean = false;
  @ViewChild('myTabGroup', {static: true}) myTabGroup!: ElementRef;
  @Input()   listImage: any[] = [
    {
      fileType: EnumFileTypeUpload.IMAGE_FRONT,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.image_front'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE_IMAGE,
    },
    {
      fileType: EnumFileTypeUpload.IMAGE_BACK,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.image_back'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE_IMAGE,
    },
    {
      fileType: EnumFileTypeUpload.AVATAR,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.customer_avatar'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE_IMAGE,
    },
    {
      fileType: EnumFileTypeUpload.BUSINESS_LICENSE_FRONT,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.business_license_front'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE,
    },
    {
      fileType: EnumFileTypeUpload.BUSINESS_LICENSE_BACK,
      fileName: '',
      fileContentBase64: '',
      fileTitle:  this.message.getMessage('kyc.business_license_back'),
      fileSize: 0,
      error: 0,
      accept: EnumFomatUploadFile.UPLOAD_FILE,
    },
  ];
  image: Record<string, any> = {};
  url: string = './assets/images/slide-bar_01.jpg'
  imageUrl = './assets/images/slide-bar_01.jpg'
  SIZE_ERROR = 1;
  TYPE_ERROR = 2
  byteArray;
  fullscreen = false
  /**
   * Detect form changing
   */
  fileTooLarge = false;
  public loading: boolean;
  public avatarUrl: string;
  fileImageUpload: any = '';
  public previewVisible: boolean;
  constructor(private toastr: ToastrService,
    public dialog: MatDialog,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private customerService: CustomerService,
    private sanitizer: DomSanitizer,
    private message: Message,) {
    this.previewVisible = false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.listImageResponse && this.listImageResponse.length > 0) {
      this.getImageByUrl();
    }
    if(changes && changes.type) {
      this.listImage = this.listImage.map((image) => ({
        ...image,
        typeDisplay: image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_FRONT || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_BACK ? 'enterprise' : 'personal'
      }))
    }
  }

  byteToBlob(image) {
    let type = image.fileName.split('.').pop();
    const byteArray = new Uint8Array(image.dataInByte)
    const blob = new Blob([byteArray], { type: EnumTypeImage.JPEG });
    // Tạo URL cho blob
    return URL.createObjectURL(blob);
  }

  ngOnInit() {
    this.listImage = this.listImage.map((image) => ({
      ...image,
      typeDisplay: image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_FRONT || image.fileType === EnumFileTypeUpload.BUSINESS_LICENSE_BACK ? 'enterprise' : 'personal'
    }))
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
  const reader = new FileReader();

  reader.onload = () => {
    this.byteArray = new Uint8Array(reader.result as ArrayBuffer);

  };

  reader.readAsArrayBuffer(file);
  }

  getImageByUrl() {
    let listApi = [];
    this.listImageResponse.forEach(element => {
      listApi = [...listApi, this.customerService.getImageByPath(element.id)]
    });
    forkJoin(listApi).subscribe((response) => {
      response.forEach((item, index) => {
        if(this.listImageResponse[index].fileName.split('.')[1] === 'pdf') {
          this.downLoadFile(item, 'application/pdf', this.listImageResponse[index]);
        } else {
          this.downLoadFile(item, EnumTypeImage.JPEG, this.listImageResponse[index]);
        }
      })
    });
  }

  downLoadFile(data: any, type: string, template: any) {
    const blob = new Blob([data], { type });
    this.listImage.forEach(item => {
      if(item.fileType == template.fileType){
        item.fileName = template.fileName;
        item.fileSize = template.fileSize;
        this.blob2Base64(blob).then(res => {
          item.fileContentBase64 = res
        }
        );
      }
    })

  }

  blob2Base64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => resolve(reader.result.toString());
      reader.onerror = error => reject(error);
    })
  }


  downloadImage(index: number){
    let link = document.createElement('a');
    link.href = this.listImage[index].fileContentBase64;
    link.download = this.listImage[index].fileName;
    document.body.appendChild(link);
    link.click();
    // URL.revokeObjectURL(url);
  }

  deleteImage(index){
    this.listImage[index].fileContentBase64 = '';
    this.listImage[index].fileSize = 0
    this.imageUpload.emit(this.listImage)
  }

  handleChange(info: { file: NzUploadFile }, index: number): void {
    info.file['index'] = index
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          // this.fileUpload = info.file;
          // this.avatarUrl = img;
          this.listImage[index].fileContentBase64 = img;
          this.listImage[index].fileName = info.file.name;
          this.listImage[index].fileSize = info.file.size;
          if(this.type === 'personal') {
            if(info.file.size > 5 * 1024 * 1024 && (this.listImage[index].fileType == EnumFileTypeUpload.IMAGE_FRONT || this.listImage[index].fileType == EnumFileTypeUpload.IMAGE_BACK)) {
              this.toastr.error(this.message.getMessage('messages.image_must_than_5m_only'));
              this.deleteImage(index);
            } else {
              const totalSize = this.listImage.reduce((accumulator, currentValue) => accumulator + currentValue.fileSize, 0);
              if (totalSize > 10 * 1024 * 1024) {
                this.toastr.error(this.message.getMessage('messages.image_must_than_10m'));
                this.deleteImage(index);
              } else {
                this.imageUpload.emit(this.listImage);
              }  
            }
          } else {
            if (info.file.size > 10 * 1024 * 1024) {
              this.toastr.error(this.message.getMessage('messages.image_must_than_10m_only'));
              this.deleteImage(index);
            } else {
              this.imageUpload.emit(this.listImage);
            }
          }
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  handlePreview = async (file: NzUploadFile) => {
    this.previewVisible = true;
  }

  dummyRequest = ({ file, onSuccess, onError }) => {
    this.fileImageUpload = file;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  beforeUpload = (file: NzUploadFile, fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpegOrJpgOrPngOrBmp = file.type === EnumTypeImage.JPEG || file.type === EnumTypeImage.JPG || file.type === EnumTypeImage.PNG || file.type === EnumTypeImage.BMP;
      const isJpegOrJpgOrPngOrBmpOrPdf = file.type === EnumTypeImage.JPEG || file.type === EnumTypeImage.JPG || file.type === EnumTypeImage.PNG || file.type === EnumTypeImage.BMP || file.type === 'application/pdf';
      if (this.type === 'personal') {
          if (!isJpegOrJpgOrPngOrBmp) {
            this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg_bmp_jpeg'));
            observer.complete();
            return;
          }
      }
      if (this.type === 'enterprise') {
          if (!isJpegOrJpgOrPngOrBmpOrPdf) {
            this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg_bmp_jpeg_pdf'));
            observer.complete();
            return;
          }
      }
      if (this.type === 'personal') {
        observer.next(isJpegOrJpgOrPngOrBmp);
      } else {
        observer.next(isJpegOrJpgOrPngOrBmpOrPdf);
      }
      observer.complete();
    });
  }

  toggleFullscreen(image, event) {
    event.stopPropagation();
    const img = image
    if (img.classList.contains('fullscreen')) {
      img.classList.remove('fullscreen');
      img.classList.add('small');
      this.isModeImage = 'normal';
    } else {
      img.classList.add('fullscreen');
      img.classList.remove('small');
      this.isModeImage = 'preview';
    }
  }

  previewPdf(dataFile: { fileName: string, filePathBase64: string }, event: any) {
    console.log(dataFile);
    event.stopPropagation();
    const data = {
        filePathBase64: dataFile.filePathBase64.split(',')[1],
        fileName: dataFile.fileName,
      };

      const dialogRef = this.dialog.open(ViewFilePdfComponent, {
        width: '1000px',
        data,
      });
      dialogRef.afterClosed().subscribe(rs => {
      });
}
}
